import React, {useState, useEffect, useContext} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Typography from "@material-ui/core/Typography";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {TextInput} from "Ficha/components/TextInput";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomSnackbar from "components/Snackbar/CustomSnackbar.js";
import { UserContext } from 'context/userContext'
import { useForm } from 'react-hook-form'
import { atualizarOpcoes } from 'firebase/firestoreData'

const useStyles = makeStyles(theme => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  field:{
    margin: 10,
    maxWidth: '95%'
  },
  updateBtn: {
    maxWidth: 400,
    margin: '20px 40px 40px 20px'
  },
  help:{
    position: 'absolute',
    top: 20,
    right: 100,
    maxWidth: '43vw',
    zIndex: 1100,
    [theme.breakpoints.down("xs")]: {
      right: 55,
    },
  },
  mobileHide:{
    [theme.breakpoints.down("xs")]: {
      display: 'none',
    },
  },
  mobileTitle:{
    display: 'none',
    [theme.breakpoints.down("xs")]: {
      display: 'inline',
    },
  },
  heading: {
    marginLeft: 10,
  },
}))

export default function Profile() {
  const classes = useStyles();
  const {currentUser, userOptions} = useContext(UserContext)
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const { register, handleSubmit, setValue } = useForm()
  const options = userOptions ? userOptions : {}

  useEffect(() => {
    setValue('procedimentosPadrao', options.procedimentosPadrao);
    setValue('anestesiasPadrao', options.anestesiasPadrao);
    setValue('adversosPadrao', options.adversosPadrao);
    setValue('alergiasPadrao', options.alergiasPadrao);
    setValue('comorbidadesPadrao', options.comorbidadesPadrao);
    setValue('medicamentosPadrao', options.medicamentosPadrao);
    setValue('examePadrao', options.examePadrao);
    setValue('prescricaoPadrao1', options.prescricaoPadrao1);
    setValue('prescricaoPadrao2', options.prescricaoPadrao2);
    setValue('prescricaoPadrao3', options.prescricaoPadrao3);
    setValue('prescricaoPadrao4', options.prescricaoPadrao4);
    setValue('prescricaoPadrao5', options.prescricaoPadrao5);
   }, [options, setValue]);

  function handleCloseMessage() {
    setShowSuccessMessage(false)
  }

  const onSubmit = data => {
    atualizarOpcoes(currentUser.uid, data)
    setShowSuccessMessage(true)
  };

  return (
    <div>
    <Accordion className={classes.help}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <HelpOutlineIcon/>
        <Typography className={classes.heading}>
          <b><span className={classes.mobileHide}>O que são as Opções de Preenchimento?</span></b>
          <b><span className={classes.mobileTitle}>Ajuda</span></b>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          É aqui que você escolhe o que será preenchido automaticamente nos
          respectivos campos da ficha de anestesia.<br/>
          Desse modo, quando o paciente negar alergias, você pode preferir
          que esse campo seja preenchido da forma que julgar mais conveniente,
          exemplos: "Nega Alergias",
          "Desconhece Alergias", "-", "Ø" ou até mesmo deixar em branco.<br/>
          <br/>
          Os últimos campos são as <b>Prescrições Padrões</b>. Salve até 5 prescrições
          para economizar tempo e não precisar digitar repetidamente na ficha de APA.<br/>
        </Typography>
      </AccordionDetails>
    </Accordion>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Opções de Preenchimento da APA</h4>
              <p className={classes.cardCategoryWhite}>Defina aqui o texto padrão
              para ser automaticamente preenchido nas suas fichas de APA

              </p>
            </CardHeader>
            <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <GridContainer className={classes.grid}>
                <TextInput label="Paciente negou PROCEDIMENTOS prévios" name="procedimentosPadrao" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Paciente negou ANESTESIAS prévias" name="anestesiasPadrao" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Paciente negou EVENTOS ADVERSOS prévios" name="adversosPadrao" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Paciente negou ALERGIAS" name="alergiasPadrao" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Paciente negou COMORBIDADES" name="comorbidadesPadrao"  className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Paciente negou uso de MEDICAMENTOS" name="medicamentosPadrao" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Exame Físico Normal" multiline name="examePadrao" defaultValue={`GERAL: B.E.G., L.O.T.E., mucosas coradas, eupnéico, anictérico
ACV: BRNF em 2 tempos, sem sopros
AR: MV presentes em AHT, sem ruídos adventícios
Extremidades: bem perfundidas, sem edemas`} className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Prescrição 1" multiline maxLength={500} name="prescricaoPadrao1" placeholder="Pressione Enter para adicionar linhas" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Prescrição 2" multiline maxLength={500} name="prescricaoPadrao2" placeholder="Pressione Enter para adicionar linhas" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Prescrição 3" multiline maxLength={500} name="prescricaoPadrao3" placeholder="Pressione Enter para adicionar linhas" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Prescrição 4" multiline maxLength={500} name="prescricaoPadrao4" placeholder="Pressione Enter para adicionar linhas" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
                <TextInput label="Prescrição 5" multiline maxLength={500} name="prescricaoPadrao5" placeholder="Pressione Enter para adicionar linhas" className={classes.field} InputLabelProps={{shrink: true}} ref={register}/>
              </GridContainer>
              <Button className={classes.updateBtn} type="submit" color="primary">Atualizar Opções</Button>
            </form>
            <CustomSnackbar open={showSuccessMessage} onClose={handleCloseMessage} message={"Opções atualizadas com sucesso"}/>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
